import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            titlePage: '',
            showPersonalMessage: false,
            selectedImage: null,
            selectedImagePreview: null,
            imageUrl: null,
            trainingTypes: [],
            selectedTrainingTypes: [],
            priority: 'LOW',
            sendNotification: false,
            orderNumber: 0,
            companyInfoId: null,
            companyInfoType: null,
            link: '',
            text: '',
            enText: '',
            title: '',
            enTitle: '',
            id: null
        }
    },
    methods: {
        addNotification: addNotification,
        editNotification: editNotification,
        resetField: resetField,
        getChipClass: getChipClass,
        makeTrainingTypes: makeTrainingTypes,
        getTrainingTypes: getTrainingTypes,
        isSelected: isSelected,
        loadTextFromFile: loadTextFromFile,
        clickTrainingTypes: clickTrainingTypes,
        getNotificationById: getNotificationById,
        uploadPhoto: uploadPhoto,
        getCompanyInfoItem: getCompanyInfoItem,
        submit: submit,
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.id = this.$route.query.id;
        this.companyInfoId = this.$route.query.companyInfoId;
        if(this.id == null){
            this.titlePage = this.locale.t('label_add_notification')
        }else{
            this.titlePage = this.locale.t('label_edit_notification')
            this.getNotificationById(this.id);
        }
        if(this.companyInfoId != null){
            this.getCompanyInfoItem(this.companyInfoId)
        }
        this.role = session.getRole();
        this.getTrainingTypes();
    }
}

function getCompanyInfoItem(id){
    let _self = this;
    AdminApiService.getCompanyInfoById(id)
        .then((response) => {
            let addInfo = JSON.parse(response.data.additionalInfo)
            // _self.imageUrl = response.data.imageMain
            _self.title = response.data.name
            _self.enTitle = response.data.enName
            _self.text = response.data.longDescription
            _self.enText = response.data.enLongDescription
            _self.imageUrl = response.data.imageMain;
            _self.companyInfoType = response.data.type;

        })
        .catch((error) => {
            console.log(error);
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function getNotificationById(){
    let _self = this;
    AdminApiService.getNotificationById(this.id)
        .then((response) => {
            _self.text = response.data.text;
            _self.title = response.data.title;
            _self.enText = response.data.enText;
            _self.enTitle = response.data.enTitle;
            _self.priority = response.data.priority;
            _self.link = response.data.link;
            _self.imageUrl = response.data.imageUrl;
            _self.orderNumber = response.data.orderNumber;
            if(response.data.trainingTypes != null){
                _self.selectedTrainingTypes = response.data.trainingTypes.split(",")
                _self.showPersonalMessage = _self.selectedTrainingTypes.length > 0;
            }
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function submit(){
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    if(this.selectedImage == null){
        this.addNotification(this.imageUrl);
        return;
    }
    this.uploadPhoto()
}

function uploadPhoto() {
    let _self = this;
    AdminApiService.uploadImageCompanyInfo(this.selectedImage)
        .then((response) => {
            _self.addNotification(response.data.url);
        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function editNotification(url){
    let model = {
        id: Number(this.id),
        text: this.text,
        enText: this.enText,
        priority: this.priority,
        link: this.link,
        title: this.title,
        enTitle: this.enTitle,
        imageUrl: url,
        orderNumber: this.orderNumber,
        sendNotification: this.sendNotification,
        trainingTypes: this.makeTrainingTypes()
    }
    let _self = this;

    AdminApiService.editNotification(model)
        .then((response) => {
            _self.resetField();
            swal(LocService.t('label_success'),LocService.t('label_notification_edit_success'), 'success')
            _self.$router.push(CONFIG_COMPANY.HOME);
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function resetField(){
    this.text = '';
    this.priority= 'LOW';
    this.link = ''
    this.enText = ''
    this.id = null;
    this.titlePage = LocService.t('label_add_notification')
}

function loadTextFromFile(ev) {
    var i = 0;
    for (i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        if (file.size > 5000000) {
            alert(this.locale.t('label_max_size_picture'))
            return
        }
        const reader = new FileReader();
        this.selectedImage = file;
        this.selectedImagePreview = URL.createObjectURL(file);
        reader.onload = e => {
            // console.log(e.target.result);
            // _self.files.push(e.target.result);
        }

        reader.readAsDataURL(file);

    }

}

function addNotification(url) {
    if(this.text.length === 0){
        swal(LocService.t('label_error'), LocService.t('label_notification_empty'), 'warning')
        return;
    }

    if(this.title == null || this.title.length === 0){
        swal(LocService.t('label_error'), LocService.t('label_notification_title_empty'), 'warning')
        return;
    }

    if(this.id != null){
        this.editNotification(url);
        return;
    }

    let model = {
        text: this.text,
        enText: this.enText,
        priority: this.priority,
        link: this.link,
        title: this.title,
        enTitle: this.enTitle,
        imageUrl: url,
        orderNumber: this.orderNumber,
        sendNotification: this.sendNotification,
        trainingTypes: this.makeTrainingTypes(),
        companyInfoId: this.companyInfoId,
        companyInfoType: this.companyInfoType,
    }

    let _self = this;
    AdminApiService.addNotification(model)
        .then((response) => {
            _self.resetField();
            swal(LocService.t('label_success'),LocService.t('label_notification_add_success'), 'success')
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function makeTrainingTypes(){
    if(this.selectedTrainingTypes.length === 0) return null
    var makeString = ""
    for(var i =0; i< this.selectedTrainingTypes.length; i++){
        makeString += this.selectedTrainingTypes[i]
        if(i < this.selectedTrainingTypes.length - 1){
            makeString += ","
        }
    }
    return makeString
}

function clickTrainingTypes(item){
    if(this.selectedTrainingTypes.includes(item)){
        this.selectedTrainingTypes = this.selectedTrainingTypes.filter(e => e !== item)
    }else{
        this.selectedTrainingTypes.push(item)
    }
}

function getChipClass(item){
    if(this.selectedTrainingTypes.includes(item)){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item){
    return this.selectedTrainingTypes.includes(item)
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.trainingTypes = response.data
        })
        .catch(error => {
            console.log(error)
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Notification/Notification.js